import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useEntitiesSalesOrderProperty } from '../../../../../hooks/entities/selectors/sales-orders';

import { createColumnDefinitionBuilder } from '../../../../../components/items-table/create-column-definition-builder';

import style from '../style.module.less';
import messages from '../messages';

const OrderNumberColumnId = 'orderNumber';

const orderNumberDataBuilder = (item) => ({
  salesOrderId: item.salesOrderId,
});

const LinkedItemOrderNumber = ({ salesOrderId }) => {
  const orderNumber = useEntitiesSalesOrderProperty(salesOrderId, 'orderNumber');
  return <>{orderNumber}</>;
};

LinkedItemOrderNumber.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

const UnlinkedItemOrderNumber = () => {
  return <FormattedMessage {...messages.unlinkedItemLabel} />;
};

const OrderNumber = ({ value: item }) => {
  const orderNumber = useMemo(() => {
    return item.salesOrderId ? <LinkedItemOrderNumber salesOrderId={item.salesOrderId} /> : <UnlinkedItemOrderNumber />;
  }, [item.salesOrderId]);

  return <div className={style['order-number']}>{orderNumber}</div>;
};

OrderNumber.propTypes = {
  value: PropTypes.shape({
    salesOrderId: PropTypes.string,
  }).isRequired,
};

const createOrderNumberColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.orderNumber} />,
  accessor: OrderNumberColumnId,
  cell: OrderNumber,
  width: 1.5,
});

export { OrderNumberColumnId, orderNumberDataBuilder, createOrderNumberColumnDefinition };
